import { useState, useEffect, useCallback } from 'react';
import { getJob } from '../api/jobs-api';
import type { JobDetailDto } from '../types';

/**
 * Hook for fetching a single job with full details
 */
export function useJob(id: number | undefined) {
  const [data, setData] = useState<JobDetailDto | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchJob = useCallback(async () => {
    if (!id) {
      setData(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const job = await getJob(id);
      setData(job);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch job');
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchJob();
  }, [fetchJob]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchJob,
  };
}
